import { gql, useQuery } from '@apollo/client';

import type {
  CampaignBannerDrawerQuery,
  CampaignBannerDrawerQueryVariables,
} from '../gql/generated/schema';
import { useGQLLocale } from './locale';

export const CAMPAIGN_BANNER_DRAWER_QUERY = gql`
  query CampaignBannerDrawer($sku: String!, $locale: Locale!) {
    articles(skus: [$sku], locale: $locale) {
      campaigns {
        key
        campaignBanner {
          shortName
          countdownEndDate
          legalDisclaimerContent
          extraDisclaimerContent
          priceAfterDiscount
          campaignType {
            ... on OnlineCoupon {
              __typename
              code
              isActivated
              discountPercentage
              conditions {
                onlyHomeClub
              }
            }
            ... on Voucher {
              __typename
              code
              conditions {
                onlyHomeClub
              }
              type {
                ... on VoucherRelative {
                  __typename
                  percentage
                }
              }
            }
          }
          name
        }
      }
    }
    user {
      homeClub {
        code
      }
    }
  }
`;

export const useCampaignBannerDrawer = (sku: string, campaignKey: string) => {
  const locale = useGQLLocale();

  const { data, loading, error } = useQuery<
    CampaignBannerDrawerQuery,
    CampaignBannerDrawerQueryVariables
  >(CAMPAIGN_BANNER_DRAWER_QUERY, {
    variables: { sku, locale },
    fetchPolicy: 'cache-first',
  });

  const campaign = data?.articles?.[0]?.campaigns?.find(c => c?.key === campaignKey);
  const isHomeClubMember = !!data?.user?.homeClub?.code;

  return { campaign: campaign ?? null, isHomeClubMember, loading, hasError: !!error };
};
